export default __webpack_public_path__ + "static/Microservices-Architecture-afab51b71d753de9ff6624ce92bf04ba.webp";